module.exports = __webpack_public_path__ + "img/ic-no-renewal-bill.png";